import { AppContext } from "../../../AppContext";

/**
 * Resolve the effective Excel Web Edit capabilities for a reader email.
 *
 * Returns `null` when the feature should NOT apply (master switch off,
 * email not configured, or explicitly disabled). Whether the DOCUMENT
 * actually has an editable spreadsheet is decided by the API probe
 * (GET {api}/docs/excel/{documentId}/{openId}/info), not here.
 *
 * @param {string} email - the reader's login email address
 * @returns {object|null} resolved capabilities, or null if inactive
 */
export function resolveExcelEditConfig(email) {
  try {
    const cfg = AppContext && AppContext.ExcelWebEdit;
    if (!cfg || cfg.enabled !== true) return null;
    if (!email || typeof email !== "string") return null;

    const key = email.trim().toLowerCase();
    const readers = cfg.readers || {};
    const entry = readers[key];

    // Not listed, or explicitly disabled -> feature off for this reader.
    if (entry === undefined || entry === null || entry === false) return null;

    const defaults = cfg.defaults || {};
    const overrides = entry === true ? {} : (typeof entry === "object" ? entry : {});
    const resolved = { ...defaults, ...overrides };

    if (resolved.canView !== true) return null;

    return {
      ...resolved,
      __email: key,
      __downloadPath: (cfg.api && cfg.api.downloadPath) || "/docs/excel",
      __savePath: (cfg.api && cfg.api.savePath) || "/docs/excel/save",
    };
  } catch (e) {
    // Never let a config error break the reader.
    return null;
  }
}

/**
 * Check a file extension (reported by the API probe) against the configured
 * allow-list.
 */
export function isExcelExtensionAllowed(ext) {
  try {
    if (!ext) return false;
    const cfg = AppContext && AppContext.ExcelWebEdit;
    const extensions = (cfg && cfg.extensions) || ["xlsx", "xlsm", "csv"];
    return extensions.indexOf(String(ext).toLowerCase()) !== -1;
  } catch (e) {
    return false;
  }
}

export default resolveExcelEditConfig;
